import { render, staticRenderFns } from "./agent-invite.vue?vue&type=template&id=2f13ac49&scoped=true&"
import script from "./agent-invite.vue?vue&type=script&lang=js&"
export * from "./agent-invite.vue?vue&type=script&lang=js&"
import style0 from "./agent-invite.vue?vue&type=style&index=0&id=2f13ac49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13ac49",
  null
  
)

export default component.exports